import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ FETCH ADDRESS BY OWNER
 * Generic ADCO.Z_02_01_Address_Master lookup — ownerGuid is a
 * CorporateEntityGuid for company addresses (default ownerType).
 * Targets: AddressController.get-by-owner (ADCO.usp_Z_02_01_Address_Get_ByOwner)
 */
export const fetchAddressByOwner = async (ownerGuid, config, ownerType = "CORPORATE_ENTITY") => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/address/get-by-owner",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ OwnerType: ownerType, OwnerGuid: ownerGuid })
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : null;
    } catch (err) {
        console.error("Address Fetch Failed:", err);
        return null;
    }
};
